import { Navigate } from 'react-router-dom';
import { AppRoutes } from '../../types/appRoutes';

const HomeRedirect = () => {
  return <Navigate to={AppRoutes.routeDsnList} replace />;
};

export default HomeRedirect;
